import * as angular from 'angular';
import * as _ from 'lodash';
import template from './editShop.tpl.html';
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommon} from "../../shared/dto/aps.common";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import DataPointServiceName, {DataPointService} from "../../services/dataPoints/dataPoints.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import ShopServiceName, {ShopService} from "../../services/shops/shops.service";

let requires = [UIUtilityServiceName, LoaderServiceName, NotifyServiceName, DataPointServiceName,
  NewGuidServiceName, ShopServiceName];

export interface EditShopController {
  save(): void;
  close(): void;
  getWellKnownCheck(type: apsEnums.WellKnownCheckType): apsViewModels.ShopDataPointDetail;
  form: angular.IFormController;
  editedShop: ShopItemWithPlant;
  plants: apsViewModels.PlantItem[];
  tanks: apsCommon.IdAndName[];
  plantDataPoints: apsCommon.IdAndName[];
  shopDataPoints: {[key: number]: apsCommon.IdAndName};
  wellKnownCheckTypes: EnumOption[];
}

export interface ShopItemWithPlant extends apsViewModels.ShopItem {
  plant: apsViewModels.PlantItem;
  tank: apsCommon.IdAndName;
}

export interface EditShopControllerData {
  shop: apsViewModels.ShopItem;
}

export function openEditShop(data: EditShopControllerData,
                             $modal: mm.foundation.modal): angular.IPromise<ShopItemWithPlant> {
  return $modal.open({
    template: template,
    controller: 'EditShopCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

export default angular.module('aps.controller.editShop', requires)
  .controller('EditShopCtrl', editShopCtrl)
  .name;

function editShopCtrl(
  $modalInstance: mm.foundation.modalInstance,
  loaderService: LoaderService,
  notifyService: NotifyService,
  data: EditShopControllerData,
  dataPointService: DataPointService,
  newGuidService: NewGuidService,
  shopService: ShopService,
  uiUtilityService: UIUtilityService,
  $q: angular.IQService
) {
  let vm = this as EditShopController;

  vm.editedShop = <ShopItemWithPlant>{};
  _.assign(vm.editedShop, data.shop);

  shopService.getPlants().then(function (plantData: apsViewModels.PlantItem[]) {
    vm.plants = plantData;
    if (vm.editedShop.plantId) {
      vm.editedShop.plant = _.find(vm.plants, {id: vm.editedShop.plantId});
      if (vm.editedShop.plant) {
        vm.tanks = vm.editedShop.plant.tanks;
        if (vm.editedShop.tankId) {
          vm.editedShop.tank = _.find(vm.tanks, {id: vm.editedShop.tankId});
        }
      }
    }
  });

  vm.wellKnownCheckTypes = uiUtilityService.getListOptionsFromEnum(apsEnums.WellKnownCheckType, 1, 2)
    .concat(uiUtilityService.getListOptionsFromEnum(apsEnums.WellKnownCheckType, 4, 6))
    .concat(uiUtilityService.getListOptionsFromEnum(apsEnums.WellKnownCheckType, 7, 7))
    .concat(uiUtilityService.getListOptionsFromEnum(apsEnums.WellKnownCheckType, 32, 32))
    .concat(uiUtilityService.getListOptionsFromEnum(apsEnums.WellKnownCheckType, 35, 36))
    ;

  let newGuids: angular.IPromise<string>[] = [];
  let missingDataPoints = vm.wellKnownCheckTypes.length - data.shop.dataPoints.length;
  for (let i = 0; i < missingDataPoints; i++) {
    newGuids.push(newGuidService.getNewGuid('ShopDataPoint'));
  }

  let getFormulas = (): angular.IPromise<apsViewModels.DataPointDetail[]> => {
    return dataPointService.get(data.shop.plantId)
      .then(dataPointDetails => {
        return _.filter(dataPointDetails, dp => dp.plantLocationId === data.shop.plantLocationId);
      });
  };

  let updateShopDataPointDetails = (): angular.IPromise<any> => {
    return $q.all(newGuids).then((resolvedGuids) => {
      for (let key in vm.shopDataPoints) {
        let enumKey = parseInt(key, 10);
        let value = vm.shopDataPoints[key];

        if (value.id === null) {
          continue;
        }

        let matchingSdp = _.find(data.shop.dataPoints, (x: apsViewModels.ShopDataPointDetail) => {
          return x.wellKnownCheckType === enumKey;
        });

        let id: string = matchingSdp ? matchingSdp.id : resolvedGuids.pop();

        let sdp: apsViewModels.ShopDataPointDetail = {
          id: id,
          wellKnownCheckType: enumKey,
          dataPointId: value.id
        };

        vm.editedShop.dataPoints.push(sdp);
      }
    });
  };

  vm.save = function() {
    if (vm.form.$invalid) {
      return;
    }

    vm.editedShop.dataPoints = [];

    loaderService.loadingPromise(
      updateShopDataPointDetails()
        .then(function() {
          return shopService.updateShop(vm.editedShop).then(() => {
            $modalInstance.close(vm.editedShop);
          }, notifyService.handleApiErrors);
        }));
  };

  vm.close = function() {
    $modalInstance.close();
  };

  getFormulas().then((formulas: apsCommon.IdAndName[]) => {
    let notConfigured: apsCommon.IdAndName = {
      id: null,
      name: 'Not configured'
    };
    formulas.unshift(notConfigured);

    vm.plantDataPoints = formulas;
    vm.shopDataPoints = {};

    for (let t of vm.wellKnownCheckTypes) {
      let sdp = _.find(data.shop.dataPoints, x => x.wellKnownCheckType === t.value);
      if (sdp) {
        let dataPoint = _.find(formulas, x => x.id === sdp.dataPointId);
        vm.shopDataPoints[t.value] = dataPoint || notConfigured;
      } else {
        vm.shopDataPoints[t.value] = notConfigured;
      }
    }
  });

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/shops/editShop.controller.ts